import * as EdDsa from './EdDsa';

export { EdDsa };

export const suiteTypes = {
  EdDsa: EdDsa,
};
